<div
  class="theme-switch"
  [class.dark]="isDarkMode"
  [class.is-top-right]="isTopRight"
  (click)="onThemeToggle()"
  role="switch"
  tabindex="0"
  [attr.aria-label]="
    isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'
  "
  [attr.aria-checked]="isDarkMode"
>
  <div class="thumb">
    <ion-icon
      [name]="isDarkMode ? 'moon' : 'sunny'"
      class="thumb-icon"
    ></ion-icon>
  </div>
</div>
